import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { graphql, PageProps } from 'gatsby';
import React from 'react';
import BlogCollectionSmall from '../../../components/BlogCollectionSmall';
import BlogProductCard from '../../../components/BlogProductCard';
import If from '../../../components/If';
import Layout from '../../../components/Layout';
import { SeoBasic } from '../../../components/Seo';
import { TypeOcr, TypeOcrH4, TypeOcrH6 } from '../../../components/Types';

export default function Blog(props: PageProps) {
  const blog = props.data.allNeBlog.nodes[0];
  const tags = blog.tags;

  return (
    <Layout>
      <Stack
        direction={{ xs: 'column', sm: 'column', md: 'column', lg: 'row' }}
      >
        <Container fixed>
          <TypeOcrH4 mt={5}>{blog.title}</TypeOcrH4>
          <div
            className='blog-html'
            dangerouslySetInnerHTML={{ __html: blog.contentHtml }}
          />
        </Container>
        <Stack
          width={{ xs: '100%', sm: '100%', md: '100%' }}
          justifyContent='flex-start'
        >
          <TypeOcrH6 align='center' mt={5}>
            Read Next
          </TypeOcrH6>

          <Divider />
          <BlogCollectionSmall
            tags={[tags.length ? tags[0] : undefined]}
            size='small'
            count={4}
          ></BlogCollectionSmall>
          <If value={blog.productCards.length !== 0}>
            <TypeOcrH6 align='center' mt={3}>
              Featured in this post
            </TypeOcrH6>
            <Divider sx={{ mb: 3 }} />
            <Stack alignItems='center' justifyContent='center' width='100%'>
              {blog.productCards.map((p: any) => {
                return (
                  <Box my={1}>
                    <BlogProductCard handle={p} />
                  </Box>
                );
              })}
            </Stack>{' '}
          </If>
        </Stack>
      </Stack>
    </Layout>
  );
}

export function Head(props: HeadProps) {
  const blog = props.data.allNeBlog.nodes[0];
  return (
    <>
      <SeoBasic
        image={blog.image.url}
        imageAlt={blog.image.altText}
        title={blog.seo.title}
        path={props.location.pathname}
        description={blog.seo.description}
      />
    </>
  );
}

export const query = graphql`
  query ($handle: String) {
    allNeBlog(filter: { handle: { eq: $handle } }) {
      nodes {
        handle
        tags
        publishedAt
        image {
          url
          altText
          src_sm
          src_md
          src_lg
          src_xl
        }
        seo {
          description
          title
        }
        contentHtml
        title
        productCards
      }
    }
  }
`;
